import { useMemo } from 'react';
import { useWindowSize } from './use-window-size';

export function useIsMobile(): boolean {
  const windowSize = useWindowSize();
  return useMemo(() => (windowSize.width || 0) < 768, [windowSize]);
}
